import React from 'react';
import setupInterceptors from "./services/setupInterceptors";
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './redux/store';
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

const container = document.getElementById('root');
const root = createRoot(container);
const persistor = persistStore(store);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
setupInterceptors(store);
reportWebVitals();
